import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { HashLink } from 'react-router-hash-link';
import VehicleSelectorModal from '../../VehicleSelectorModal';

export default class SearchForm extends React.Component {

    state = {
        accessories: [],
        categories: [],
        models: [],
        years: [],
        selectedModelName: '',
        selectedModelImage: '',
        current_page: 1,
        next_page: false,
        isAccessoriesLoading: false,
        formModel: '',
        formYear: 'all',
        formCategory: 'all',
        isNewCategoryDisabled: false,
        show3dModal: false,
        accessoryIdFor3d: null,
        show3dOnly: false,
        has_3d_accessories: false,
        showRacingOnly: false,
        has_racing_category: false,
        racingCategoryId: null,
    }

componentDidMount() {
        this._isMounted = true;
        const selectedModel = localStorage.getItem('selectedModel') || 'all';
        const selectedYear = localStorage.getItem('selectedYear') || 'all';
        const selectedCategory = this.props.initialCategoryId || localStorage.getItem('selectedCategory') || 'all';
        const show3dOnly = this.props.initialShow3dOnly === true;

        if (this.props.initialCategoryId) localStorage.setItem('selectedCategory', this.props.initialCategoryId);

        this.setState({
            formModel: selectedModel,
            formYear: selectedYear,
            formCategory: selectedCategory,
            show3dOnly
        }, () => {
            this.fetchInitialData();
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

fetchInitialData = () => {
        const { formModel, formYear, formCategory, show3dOnly, showRacingOnly, racingCategoryId } = this.state;

        if (formModel && formModel !== 'all') {
            this.fetchYears(formModel);
            this.fetchModelDetails(formModel);
        } else {
            this.setState({ years: [] });
        }

        let filter = '';
        if(formModel && formModel !== 'all') filter += '&model_id=' + formModel;
        if(formYear && formYear !== 'all') filter += '&year_id=' + formYear;
        if (process.env.REACT_APP_BRAND_ID === '1' && showRacingOnly && racingCategoryId) {
            filter += '&category_id=' + racingCategoryId;
        } else {
            if(formCategory && (formCategory !== 'all' && formCategory !== 'new')) filter += '&category_id=' + formCategory;
            if(formCategory && formCategory === 'new') filter += '&per_page=9&order_by=created_at&order_by_dir=desc&limit=9';
        }
        if(process.env.REACT_APP_BRAND_ID === '1' && show3dOnly) filter += '&show_3d_only=1';

        this.fetchAccessories(filter);
        this.fetchModels();
        this.fetchCategories();
    }

fetchYears = (modelId) => {
    const dealer_id = localStorage.getItem('dealer_id');
    let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const config = {
        headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
    };

    axios.get(
        `${process.env.REACT_APP_FORD_API_URL}/api/v1/car-models/${modelId}?dealer_id=${dealer_id}&brand_id=${process.env.REACT_APP_BRAND_ID}&market_id=${process.env.REACT_APP_MARKET_ID}`,
        config
    ).then(res => {
        if (!this._isMounted) return;
        const years = [...(res.data.years || [])].sort(
            (a, b) => (parseInt(b.year || b.name, 10) || 0) - (parseInt(a.year || a.name, 10) || 0)
        );
        this.setState({ years });
    });
}

fetchModelDetails = (modelId) => {
    let language = localStorage.getItem('language') || 'en';
    if (modelId === 'all') {
        this.setState({ 
            selectedModelName: 'All Models',
            selectedModelImage: ''
        });
        return;
    }

    const dealer_id = localStorage.getItem('dealer_id');
    let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const config = {
        headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
    };

    axios.get(
        `${process.env.REACT_APP_FORD_API_URL}/api/v1/car-models/${modelId}?dealer_id=${dealer_id}&brand_id=${process.env.REACT_APP_BRAND_ID}&market_id=${process.env.REACT_APP_MARKET_ID}`,
        config
    ).then(res => {
        if (!this._isMounted) return;
        this.setState({
            selectedModelName: res.data.name,
            selectedModelImage: res.data.media[0].original_url
        });
    });
}

fetchAccessories = (filter) => {
    const dealer_id = localStorage.getItem('dealer_id');
    const country_id = localStorage.getItem('country_id') || '';
    const countryParam = country_id ? `&country_id=${country_id}` : '';
    let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const config = {
        headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
    };

    this.setState({ isAccessoriesLoading: true });
    axios.get(
        `${process.env.REACT_APP_FORD_API_URL}/api/v1/accessories/filter?dealer_id=${dealer_id}&per_page=12${filter}${countryParam}&brand_id=${process.env.REACT_APP_BRAND_ID}&market_id=${process.env.REACT_APP_MARKET_ID}`,
        config
    ).then(res => {
        this.setState({
            accessories: res.data.data,
            next_page: !!res.data.next_page_url,
            has_3d_accessories: !!res.data.has_3d_accessories,
            isAccessoriesLoading: false,
        });
    }).catch((err) => {
        console.error('Error fetching accessories:', err);
        this.setState({ isAccessoriesLoading: false });
    });
}

fetchModels = () => {
    const dealer_id = localStorage.getItem('dealer_id');
    let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const config = {
        headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
    };

    axios.get(
        `${process.env.REACT_APP_FORD_API_URL}/api/v1/car-models/filter?brand_id=${process.env.REACT_APP_BRAND_ID}&dealer_id=${dealer_id}&market_id=${process.env.REACT_APP_MARKET_ID}`,
        config
    ).then(res => {
        if (!this._isMounted) return;
        const language = localStorage.getItem('language') || 'en';
        const models = [...(res.data.data || [])].sort((a, b) =>
            String(a?.name || '').localeCompare(String(b?.name || ''), language, { sensitivity: 'base' })
        );
        this.setState({ models });
    });
}

fetchCategories = () => {
    const dealer_id = localStorage.getItem('dealer_id');
    let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const config = {
        headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
    };

    let url = `${process.env.REACT_APP_FORD_API_URL}/api/v1/categories?dealer_id=${dealer_id}&brand_id=${process.env.REACT_APP_BRAND_ID}&market_id=${process.env.REACT_APP_MARKET_ID}`;
    if (this.state.formModel && this.state.formModel !== 'all') {
        url += '&model_id=' + encodeURIComponent(this.state.formModel);
        if (this.state.formYear && this.state.formYear !== 'all') {
            url += '&year_id=' + encodeURIComponent(this.state.formYear);
        }
    }

    axios.get(url, config).then(res => {
        if (!this._isMounted) return;
        const categories = res.data || [];
        const language = localStorage.getItem('language') || 'en';
        let racingCategoryId = null;

        categories.forEach((category) => {
            if (!category || !category.name) return;
            const name = (category.name || '').toString().trim();
            if (
                (language === 'en' && name === 'Performance') ||
                (language === 'ar' && name === 'أداء')
            ) {
                racingCategoryId = category.id;
            }
        });

        categories.sort((a, b) =>
            String(a?.name || '').localeCompare(String(b?.name || ''), language, { sensitivity: 'base' })
        );

        const isInitialRacingCategory =
            racingCategoryId &&
            String(this.state.formCategory) === String(racingCategoryId);

        const isFordBrand = process.env.REACT_APP_BRAND_ID === '1';
        this.setState({
            categories,
            racingCategoryId,
            has_racing_category: !!racingCategoryId,
            showRacingOnly:
                isFordBrand && racingCategoryId
                    ? (isInitialRacingCategory || this.state.showRacingOnly)
                    : false,
        });
    });
}

handleModelChange = (event) => {
    const selectedModel = event.target.value;
    localStorage.setItem('selectedModel', selectedModel);
    this.setState({ 
        formModel: selectedModel, 
        formYear: 'all',  // Reset year to 'all' when model changes
//        formCategory: 'all',  // Reset category to 'all' when model changes
        years: [],
        isNewCategoryDisabled: selectedModel !== 'all',
        show3dOnly: false,  // Reset 3D-only filter when model changes so checkbox hides for models without 3D accessories
        showRacingOnly: false,
    }, () => {
        if (selectedModel && selectedModel !== 'all') {
            this.fetchYears(selectedModel);
        }
        this.submitForm();
    });
    
    if(selectedModel != 'all'){
        console.log(selectedModel);
        let selectedCategory = localStorage.getItem('selectedCategory');
        console.log(selectedCategory);
        if(selectedCategory == 'new'){
            localStorage.setItem('selectedCategory', 'all');
            localStorage.setItem('selectedCategoryName', 'All Categories');
            this.setState({ formCategory: 'all' }, this.submitForm);
        }
    }

    // Clear year and category from localStorage when model changes
    localStorage.removeItem('selectedYear');
//    localStorage.removeItem('category_id');
};

handleYearChange = (event) => {
    const selectedYear = event.target.value;
    localStorage.setItem('selectedYear', selectedYear);
    this.setState({ formYear: selectedYear, show3dOnly: false, showRacingOnly: false }, this.submitForm);
};

handleCategoryChange = (event) => {
    const selectedCategory = event.target.value;
    let selectedCategoryName = 'All Categories';
    const { racingCategoryId } = this.state;

    if (selectedCategory !== 'all') {
        // Find the selected option to get its text content (category name)
        const selectedOption = event.target.options[event.target.selectedIndex];
        selectedCategoryName = selectedOption.textContent;
    }

    // Store category ID and name in localStorage
    localStorage.setItem('selectedCategory', selectedCategory);
    localStorage.setItem('selectedCategoryName', selectedCategoryName);

    const isRacingCategory =
        racingCategoryId &&
        String(selectedCategory) === String(racingCategoryId);

    this.setState(
        {
            formCategory: selectedCategory,
            show3dOnly: false,
            showRacingOnly:
                process.env.REACT_APP_BRAND_ID === '1' && !!isRacingCategory,
        },
        this.submitForm
    );
};

handleShow3dOnlyChange = (event) => {
    this.setState({ show3dOnly: event.target.checked }, this.submitForm);
};

handleShowRacingOnlyChange = (event) => {
    if (process.env.REACT_APP_BRAND_ID !== '1') {
        return;
    }
    const checked = event.target.checked;
    const { racingCategoryId, categories } = this.state;
    const language = localStorage.getItem('language') || 'en';

    if (!racingCategoryId) {
        this.setState({ showRacingOnly: false }, this.submitForm);
        return;
    }

    if (checked) {
        const racingCategory = (categories || []).find(
            (c) => c && String(c.id) === String(racingCategoryId)
        );
        const fallbackName =
            language === 'en' ? 'Performance' : 'أداء';
        const name = racingCategory && racingCategory.name
            ? racingCategory.name
            : fallbackName;

        localStorage.setItem('selectedCategory', String(racingCategoryId));
        localStorage.setItem('selectedCategoryName', name);

        this.setState(
            {
                showRacingOnly: true,
                formCategory: 'all',
                accessories: [],
                next_page: false,
                current_page: 1,
            },
            this.submitForm
        );
    } else {
        localStorage.setItem('selectedCategory', 'all');
        localStorage.setItem(
            'selectedCategoryName',
            language === 'en' ? 'All Categories' : 'كل الفئات'
        );

        this.setState(
            {
                showRacingOnly: false,
                formCategory: 'all',
                accessories: [],
                next_page: false,
                current_page: 1,
            },
            this.submitForm
        );
    }
};

submitForm = () => {
    const { formModel, formYear, formCategory, show3dOnly, showRacingOnly, racingCategoryId } = this.state;
    let filter = '';
    if(formModel && formModel !== 'all') filter += '&model_id=' + formModel;
    if(formYear && formYear !== 'all') filter += '&year_id=' + formYear;
    if (process.env.REACT_APP_BRAND_ID === '1' && showRacingOnly && racingCategoryId) {
        filter += '&category_id=' + racingCategoryId;
    } else {
        if(formCategory && (formCategory !== 'all' && formCategory !== 'new')) filter += '&category_id=' + formCategory;
        if(formCategory && formCategory === 'new') filter += '&per_page=9&order_by=created_at&order_by_dir=desc&limit=9';
    }
    if(process.env.REACT_APP_BRAND_ID === '1' && show3dOnly) filter += '&show_3d_only=1';

    this.setState({ current_page: 1 });
    this.fetchAccessories(filter);
    this.fetchModelDetails(formModel);
    this.fetchCategories(); // Refetch so category list is model-aware (e.g. Performance only for Bronco)
};

handlePreviousClick = (event) => {
    let current_page = this.state.current_page - 1;
    this.setState({ current_page });
    this.fetchPagedAccessories(current_page);
}

handleNextClick = (event) => {
    let current_page = this.state.current_page + 1;
    this.setState({ current_page });
    this.fetchPagedAccessories(current_page);
}

fetchPagedAccessories = (page) => {
    const { formModel, formYear, formCategory, show3dOnly, showRacingOnly, racingCategoryId } = this.state;
    const dealer_id = localStorage.getItem('dealer_id');
    const country_id = localStorage.getItem('country_id') || '';
    const countryParam = country_id ? `&country_id=${country_id}` : '';
    let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const config = {
        headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
    };

    let filter = '';
    if(formModel && formModel !== 'all') filter += '&model_id=' + formModel;
    if(formYear && formYear !== 'all') filter += '&year_id=' + formYear;
    if (process.env.REACT_APP_BRAND_ID === '1' && showRacingOnly && racingCategoryId) {
        filter += '&category_id=' + racingCategoryId;
    } else {
        if(formCategory && (formCategory !== 'all' && formCategory !== 'new')) filter += '&category_id=' + formCategory;
        if(formCategory && formCategory === 'new') filter += '&per_page=9&order_by=created_at&order_by_dir=desc&limit=9';
    }
    if(process.env.REACT_APP_BRAND_ID === '1' && show3dOnly) filter += '&show_3d_only=1';
    filter += '&page=' + page;

    axios.get(
        `${process.env.REACT_APP_FORD_API_URL}/api/v1/accessories/filter?dealer_id=${dealer_id}&per_page=12${filter}${countryParam}&brand_id=${process.env.REACT_APP_BRAND_ID}&market_id=${process.env.REACT_APP_MARKET_ID}`,
        config
    ).then(res => {
        if (!this._isMounted) return;
        this.setState({
            accessories: res.data.data,
            next_page: !!res.data.next_page_url,
            has_3d_accessories: !!res.data.has_3d_accessories,
        });
    });
}

slugify(text) {
    return text.toString().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\p{L}\p{N}\-]+/gu, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}

renderHeading = () => {
        const selectedCategory = localStorage.getItem('selectedCategory');
        const selectedCategoryName = localStorage.getItem('selectedCategoryName');
        const { selectedModelName, selectedModelImage } = this.state;

        if ((!this.state.formModel || this.state.formModel === 'all') && selectedCategory && selectedCategory !== 'all') {
            return <span>{selectedCategoryName}</span>;
        } else {
            return (
                <>
                    <span language="ar">ملحقات من أجل</span>
                    <span language="en">Accessories for </span>
                    {' '}
                    {selectedModelName}
                    {selectedModelName !== 'All Models' && selectedModelImage && (
                        <img 
                            className="m-2" 
                            style={{ width: '100px', height: 'auto' }} 
                            src={selectedModelImage} 
                            alt={selectedModelName} 
                        />
                    )}
                </>
            );
        }
    }

render() {
        const { accessories, categories, models, years, current_page, next_page, isAccessoriesLoading, selectedModelName, selectedModelImage, formModel, formYear, formCategory, isNewCategoryDisabled, show3dOnly, has_3d_accessories, showRacingOnly, has_racing_category, racingCategoryId } = this.state;
    let hasHeroImage = false;
    let language = localStorage.getItem('language') || 'en';
    const show3dCheckbox = process.env.REACT_APP_BRAND_ID === '1' && has_3d_accessories;
    const showRacingCheckbox = process.env.REACT_APP_BRAND_ID === '1' && has_racing_category;

    return (
        <div className="container">
            <div className="d-block">
                <div className="filter-form">
                    <form>
                        <div className="row">
                            <div className="col-12 col-md-4 col-lg-3 col-xl-3">
                                <select className="form-select" aria-label="" onChange={this.handleModelChange} value={formModel}>
                                    <option value='all'>
                                        {language === 'en' ? 'All Models' : 'كل الموديلات'}
                                    </option>
                                    {models.map((model, key) => (
                                        <option key={key} value={model.id}>{model.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-12 col-md-4 col-lg-3 col-xl-3">
                                <select className="form-select" aria-label="" onChange={this.handleYearChange} value={formYear} disabled={!formModel || formModel === 'all'}>
                                    <option value='all'>
                                        {language === 'en' ? 'All Years' : 'كل السنوات'}
                                    </option>
                                    {years.map((year, key) => (
                                        <option key={key} value={year.id}>{year.year}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-12 col-md-4 col-lg-3 col-xl-3">
                                <select 
                                    className="form-select" 
                                    aria-label="" 
                                    onChange={this.handleCategoryChange} 
                                    value={this.state.formCategory}
                                >
                                    <option value='all'>
                                        {language === 'en' ? 'All Categories' : 'كل الفئات'}
                                    </option>
                                    {categories
                                        .filter((category) => !racingCategoryId || String(category.id) !== String(racingCategoryId))
                                        .map((category, key) => (
                                            <option key={key} value={category.id}>{category.name}</option>
                                        ))}
                                    <option value='new' disabled={isNewCategoryDisabled}>
                                        {language === 'en' ? 'New Accessories' : 'ملحقات جديدة'}
                                    </option>
                                </select>
                            </div>
                        </div>                
                    </form>
                </div>
            </div>

            <div className="accessories">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                    <h2 className="mb-0">{this.renderHeading()}</h2>
                    <div className="d-flex align-items-center gap-3">
                        {show3dCheckbox && (
                            <label className="d-flex align-items-center gap-2 mb-0 accessory-show-3d-only" style={{ cursor: 'pointer', fontWeight: 'normal' }}>
                                <input type="checkbox" checked={show3dOnly} onChange={this.handleShow3dOnlyChange} className="form-check-input" />
                                <span>{language === 'en' ? 'Show 3D Only' : 'منظر ثلاثي الأبعاد 3D فقط'}</span>
                            </label>
                        )}
                        {showRacingCheckbox && (
                            <label className="d-flex align-items-center gap-2 mb-0 accessory-show-3d-only" style={{ cursor: 'pointer', fontWeight: 'normal' }}>
                                <input type="checkbox" checked={showRacingOnly} onChange={this.handleShowRacingOnlyChange} className="form-check-input" />
                                <span>{language === 'en' ? 'Show Ford Racing only' : 'فورد ريسينج فقط'}</span>
                            </label>
                        )}
                    </div>
                </div>
                <div className="row gx-5">
                    {isAccessoriesLoading && (
                        <div className="loader-container">
                            <div className="loader">
                                <img src="/images/Rolling@1x-1.0s-200px-200px.gif" width={100} height={100} alt="Loading" />
                            </div>
                        </div>
                    )}
                    {process.env.REACT_APP_BRAND_ID === '1' && show3dOnly && (!accessories || accessories.length === 0) ? (
                        <div className="col-12 py-5 text-center accessories-empty-3d">
                            <p className="mb-0 text-muted" style={{ fontSize: '1.125rem' }}>
                                {language === 'en' ? 'No accessories found.' : 'لم يتم العثور على ملحقات.'}
                            </p>
                        </div>
                    ) : accessories && accessories.map((accessory, key) => {
                        const isRacingAccessory = !!(
                            (racingCategoryId && Array.isArray(accessory.category_ids) && accessory.category_ids.some((id) => String(id) === String(racingCategoryId))) ||
                            (racingCategoryId && String(accessory.category_id || '') === String(racingCategoryId)) ||
                            accessory.is_racing
                        );
                        const showRacingIcon =
                            process.env.REACT_APP_BRAND_ID === '1' &&
                            (isRacingAccessory || (showRacingOnly && !!racingCategoryId));
                        return (
                        <div className="col-12 col-md-6 col-lg-3" key={key}>
                            <div className="accessory">
                                <Link to={"/accessory/" +accessory.id+"/"+this.slugify(accessory.accessory_name)}>
                                    <div style={{ position: 'relative' }}>
                                    {accessory.media && accessory.media.map((media, index) => {
                                        if (media.collection_name === "print-image") {
                                            hasHeroImage = true;
                                                return <img key={index} src={media.original_url} alt={accessory.accessory_name}/>;
                                        }
                                        return null;
                                    })}
                                    { !hasHeroImage && <img src="../images/default.jpg" alt={accessory.accessory_name}/>}
                                    {hasHeroImage = false}
                                        {process.env.REACT_APP_BRAND_ID === '1' && accessory.has_3d && (
                                            <span
                                                className="badge-3d"
                                                title="3D View Available"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    this.setState({ accessoryIdFor3d: accessory.id, show3dModal: true });
                                                }}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <img src="/images/3d-icon-white-128x.png" alt="3D" />
                                            </span>
                                        )}
                                    </div>
                                </Link>
                                {showRacingIcon && (
                                    <img className="racing-logo-inline" src="/images/racing-blue.png" alt="Ford Racing" height="10px" width="auto"/>
                                )}
                                <p className="name">
                                    <Link to={"/accessory/" +accessory.id+"/"+this.slugify(accessory.accessory_name)}>{accessory.accessory_name}</Link>
                                </p>
                            </div>
                        </div>
                    )})}
                </div>
            </div>

            {process.env.REACT_APP_BRAND_ID === '1' && this.state.show3dModal && this.state.accessoryIdFor3d && (
                <VehicleSelectorModal
                    accessoryId={this.state.accessoryIdFor3d}
                    onClose={() => this.setState({ show3dModal: false, accessoryIdFor3d: null })}
                />
            )}

            { formCategory !== 'new' &&
            <div className="pagination">
                <div className="links">
                    { current_page > 1 && 
                        <span className="prev">
                            <HashLink to="#" onClick={this.handlePreviousClick}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-left" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                                    <path fillRule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                                </svg>
                                <span language="ar">سابق</span>
                                <span language="en">Previous</span>
                            </HashLink>    
                        </span>
                    }
                    <span className="current">
                        {current_page}
                    </span>
                    { next_page && 
                        <span className="next">
                            <HashLink to="#" onClick={this.handleNextClick}>
                                <span language="ar">التالي</span>
                                <span language="en">Next</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708"/>
                                    <path fillRule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708"/>
                                </svg>
                            </HashLink>
                        </span>
                    }
                </div>
            </div>
                }

        </div>
    )
}
}